/*
 *  音视频通话，响铃
 */
const videoRing = {
  play() {
    const ringAudio = document.getElementById('ringAudio');
    if (ringAudio) {
      ringAudio.muted = false;
      ringAudio.play();
    }
  },
  stop() {
    const ringAudio = document.getElementById('ringAudio');
    if (ringAudio) {
      ringAudio.pause();
    }
  },
  // 播放声音，阻止页面休眠
  playPreventPageSleep() {
    const au = document.getElementById('preventPageSleepAudio');
    if (!au) {
      return;
    }

    au.muted = false;
    au.play();
    au.volume = 0.02; // 这个音效至少需要0.02的音量，否则浏览器当作你没播放。。
    console.log('∮∮∮----------------> play');
  },
  stopPreventPageSleep() {
    const au = document.getElementById('preventPageSleepAudio');
    if (!au) {
      return;
    }
    au.pause();
    console.log('∮∮∮++++++++++++++++> stop');
  },
};

export default videoRing;
